module.exports = __webpack_public_path__ + "img/045.2ed8a68d.png";